<script lang="ts">
  import { cubicInOut } from "svelte/easing";
  import { fade, slide } from "svelte/transition";

  export let desktopContained = false;
</script>

<style lang="scss">
  .tray {
    &--contained {
      width: 100%;
      height: 100%;
      z-index: 1003;
      background-color: $surface;
      position: relative;
    }

    &-slot {
      width: 100%;
      background-color: $surface;
      z-index: 1005;
      position: absolute;
      bottom: 0;
      left: 0;
      border: 1px solid $background;

      @include retina {
        border: 0.5px solid $background;
      }

      &--contained {
        width: 100%;
        height: 100%;
        background-color: $surface;
        position: relative;
        z-index: 1005;
        pointer-events: all;
        border-top: 1px solid $background;

        @include retina {
          border-top: 0.5px solid $background;
        }
      }
    }
  }
</style>

<div
  transition:fade|global
  class={` ${desktopContained ? "tray--contained" : "tray"}`}
>
  <div
    transition:slide|global={{
      easing: cubicInOut,
    }}
    role="dialog"
    aria-modal="true"
    aria-label="modal"
    tabindex="-1"
    class={` ${desktopContained ? "tray-slot--contained" : "tray-slot"}`}
  >
    <slot />
  </div>
</div>
